import { render, staticRenderFns } from "./TheConfirmationDialog.vue?vue&type=template&id=d37c2ad8&"
import script from "./TheConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./TheConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports